import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { FaWhatsapp, FaInstagram, FaFacebook } from "react-icons/fa";
import {
  STORE_ADDRESS,
  STORE_EMAIL,
  STORE_EMAIL_HREF,
  STORE_MAP_EMBED,
  STORE_MAPS_LINK,
  STORE_PHONE,
  STORE_PHONE_HREF,
} from "../lib/storeInfo";

export default function Footer() {
  return (
    <footer className="bg-navy-900 border-t border-gold/20 mt-24">
      <div className="site-container pt-12 pb-8 flex flex-col gap-10">

        {/* Top row: brand + nav columns */}
        <div className="grid grid-cols-2 md:grid-cols-[1fr_1fr_1fr_1fr_1.5fr] gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/logo.png" alt="GamesTrade" className="h-10 w-10 object-contain" style={{ filter: "drop-shadow(0 0 4px rgba(245,197,24,0.35))" }} />
              <div>
                <div className="font-black text-base tracking-widest leading-none">GAMES<span className="text-gold">TRADE</span></div>
                <div className="text-[9px] uppercase tracking-[0.25em]"><span className="text-gold">You Play</span> <span className="text-white/80">We Trade</span></div>
              </div>
            </div>
            <p className="text-xs text-slate-400 leading-relaxed">India's trusted gaming destination for 25+ years. Sony Authorised. New, used &amp; pre-book.</p>
            <div className="flex gap-4 mt-4">
              <a href="https://www.instagram.com/gamestrade.in/" target="_blank" rel="noopener noreferrer" aria-label="GamesTrade on Instagram">
                <FaInstagram className="w-6 h-6 text-slate-400 hover:text-gold transition-colors" />
              </a>
              <a href="https://wa.me/918287799290" target="_blank" rel="noopener noreferrer" aria-label="GamesTrade on WhatsApp">
                <FaWhatsapp className="w-6 h-6 text-slate-400 hover:text-gold transition-colors" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100064134004301" target="_blank" rel="noopener noreferrer" aria-label="GamesTrade on Facebook">
                <FaFacebook className="w-6 h-6 text-slate-400 hover:text-gold transition-colors" />
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-xs font-extrabold uppercase tracking-[0.2em] text-gold mb-3">Shop</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/shop?category=consoles" className="hover:text-gold">Consoles</Link></li>
              <li><Link to="/shop?category=games" className="hover:text-gold">Games</Link></li>
              <li><Link to="/shop?category=accessories" className="hover:text-gold">Accessories</Link></li>
              <li><Link to="/shop?condition=upcoming" className="hover:text-gold">Pre-book</Link></li>
              <li><Link to="/shop?condition=used" className="hover:text-gold">Used Deals</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-extrabold uppercase tracking-[0.2em] text-gold mb-3">Services</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/track" className="hover:text-gold">Track Order</Link></li>
              <li><Link to="/repairs" className="hover:text-gold">Repair Service</Link></li>
              <li><Link to="/repair-track" className="hover:text-gold">Track Repair</Link></li>
              <li><Link to="/trade-in" className="hover:text-gold">Trade In</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Contact Us</Link></li>
              <li><Link to="/about" className="hover:text-gold">About Us</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-extrabold uppercase tracking-[0.2em] text-gold mb-3">Policies</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/policy/terms" className="hover:text-gold">Terms &amp; Conditions</Link></li>
              <li><Link to="/policy/refunds" className="hover:text-gold">Refunds &amp; Returns</Link></li>
              <li><Link to="/policy/privacy" className="hover:text-gold">Privacy Policy</Link></li>
              <li><Link to="/policy/shipping" className="hover:text-gold">Shipping Policy</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-extrabold uppercase tracking-[0.2em] text-gold mb-3">Contact</h4>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-gold shrink-0 mt-0.5" />
                <a href={STORE_MAPS_LINK} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors leading-snug">{STORE_ADDRESS}</a>
              </li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold shrink-0" /><a href={STORE_PHONE_HREF} className="hover:text-gold transition-colors">{STORE_PHONE}</a></li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-gold shrink-0" />
                <a href={STORE_EMAIL_HREF} className="hover:text-gold transition-colors">{STORE_EMAIL}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom row: map full width */}
        <div className="rounded-lg overflow-hidden border border-gold/20 w-full" style={{ height: "160px" }}>
          <iframe
            title="GamesTrade Noida store map"
            src={STORE_MAP_EMBED}
            className="w-full h-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

      </div>
      <div className="border-t border-gold/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} GamesTrade. All rights reserved. 25+ years of gaming. <br></br>Developed by <a href="https://www.linkedin.com/in/granth-bagadia/" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">Granth Bagadia</a>.
      </div>
    </footer>
  );
}
